import { render, staticRenderFns } from "./AdminGroupForm.vue?vue&type=template&id=aaea14a0&scoped=true"
import script from "./AdminGroupForm.vue?vue&type=script&lang=ts"
export * from "./AdminGroupForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminGroupForm.vue?vue&type=style&index=0&id=aaea14a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaea14a0",
  null
  
)

export default component.exports